import { getFocusOutlineBaseStyle } from './getFocusOutlineBaseStyle';

export function getFocusOutline(selector: string): string {
  return `
    ${selector}:focus:not(:active):not([role="dialog"]) {
      ${getFocusOutlineBaseStyle()}
    }
  `;
}
